import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Main from './Layout/Main';
import Login from './components/Account/Login'
import NoMatch from './Layout/Notfound';;
export default function App() {
    const [isauth, setisauth] = useState(false)
    const [companyid, setcompanyid] = useState("")
    useEffect(() => {
        if (localStorage.getItem("Username") && localStorage.getItem("companyname")) {

            setcompanyid(localStorage.getItem("companyname"))
            setisauth(true);
        }
        else {
            setisauth(false)
        }
    })
    const handlelogin = (val) => {
        if (localStorage.getItem("Username") && localStorage.getItem("companyname")) {
            window.location.reload();
        }
        setisauth(val)
    }
    return (
        <>
            <Switch>
                {
                    !isauth ?
                        <Route path='/' render={() => <Login isauth={handlelogin} />} />
                        :
                        <Route path='/' render={() => <Main handleLogged={handlelogin} companyid={localStorage.getItem("companyname")} usertypeid={localStorage.getItem("usertypeid")} />} />
                }
                <Route path='*' component={NoMatch} />
            </Switch>
        </>
    )

}


